import { RolesType, TId } from '../commonTypes';
import { TApartmentRole } from './store';

export const apartmentUserHandler = (apartmentId: TId, rolesType: RolesType, roles: Array<TApartmentRole>) => ({
  [rolesType]: {
    apartmentRoles: [
      {
        apartmentId,
        types: roles,
      },
    ],
  },
});

export type TApartmentMenuGroup = { type: 'group'; name: string };
export type TApartmentMenuOption = { type: 'item'; id: number; name: string };
export type TApartmentMenuItem = TApartmentMenuGroup | TApartmentMenuOption;

export interface IGroupedApartment {
  floorName: string;
  items?: { id: number; name: string; number: string }[];
}

export function getApartmentMenuItems(apartments: IGroupedApartment[] | null | undefined): TApartmentMenuItem[] {
  if (!apartments || !Array.isArray(apartments)) {
    return [];
  }
  const result: TApartmentMenuItem[] = [];
  apartments
    .toSorted((a, b) => {
      if (a.floorName === '' && b.floorName !== '') return -1;
      if (a.floorName !== '' && b.floorName === '') return 1;
      return 0;
    })
    .forEach((group) => {
      result.push({ name: group.floorName, type: 'group' });
      (group.items ?? []).forEach((option) => {
        result.push({
          id: option.id,
          name: option.name ? `${option.number} – ${option.name}` : option.number,
          type: 'item',
        });
      });
    });
  return result;
}
